import { deepmerge } from '@simplisafe/ewok'

// UK
import enGBAlarmMoments from './locales/en-GB/alarm-moments.json' with {
  type: 'json'
}
import enGBBusinessExpert from './locales/en-GB/business-expert.json' with {
  type: 'json'
}
import enGBCommon from './locales/en-GB/common.json' with { type: 'json' }
import enGBContact from './locales/en-GB/contact.json' with { type: 'json' }
import crimeInTheUk from './locales/en-GB/crime-in-the-uk.json' with {
  type: 'json'
}
import enGBFAQs from './locales/en-GB/faqs.json' with { type: 'json' }
import enUKFppIndoorCamera from './locales/en-GB/fpp-indoor-camera.json'
import enUKFppOutdoorCamera from './locales/en-GB/fpp-outdoor-camera.json'
import enGBHeader from './locales/en-GB/header.json' with { type: 'json' }
import enGBMaps from './locales/en-GB/maps.json' with { type: 'json' }
import enGBMiscBusiness from './locales/en-GB/misc.business.json' with {
  type: 'json'
}
import enGBSEO from './locales/en-GB/seo.json' with { type: 'json' }
import enGBShop from './locales/en-GB/shop.json' with { type: 'json' }
import enGBShopSMB from './locales/en-GB/shop.smb.json' with { type: 'json' }
import enGBSystemAdvisor from './locales/en-GB/system-advisor.json' with {
  type: 'json'
}
import enGBTest from './locales/en-GB/test.json' with { type: 'json' }

// US
import enUSAlarmMoments from './locales/en-US/alarm-moments.json'
import enUSBusinessExpert from './locales/en-US/business-expert.json' with {
  type: 'json'
}
import enUSCommon from './locales/en-US/common.json' with { type: 'json' }
import enUSContact from './locales/en-US/contact.json' with { type: 'json' }
import enUSEmailSubscriptions from './locales/en-US/email-subscriptions.json' with {
  type: 'json'
}
import enUSFAQs from './locales/en-US/faqs.json' with { type: 'json' }
import enUSFppIndoorCamera from './locales/en-US/fpp-indoor-camera.json'
import enUSFppOutdoorCamera from './locales/en-US/fpp-outdoor-camera.json'
import enUSHeader from './locales/en-US/header.json' with { type: 'json' }
import enUSLegal from './locales/en-US/legal.json' with { type: 'json' }
import enUSMaps from './locales/en-US/maps.json' with { type: 'json' }
import enUSMiscBusiness from './locales/en-US/misc.business.json' with {
  type: 'json'
}
import enUSBusinessMonitoring from './locales/en-US/page_business-features-alarm-monitoring.json' with {
  type: 'json'
}
import enUSProfessionalMonitoring from './locales/en-US/professional-monitoring.json' with {
  type: 'json'
}
import enUSSEO from './locales/en-US/seo.json' with { type: 'json' }
import enUSShop from './locales/en-US/shop.json' with { type: 'json' }
import enUSShopSMB from './locales/en-US/shop.smb.json' with { type: 'json' }
import enUSSystemAdvisor from './locales/en-US/system-advisor.json' with {
  type: 'json'
}
import enUSTest from './locales/en-US/test.json' with { type: 'json' }

// we keep an empty translation namespace in order to force users to use a namespace
// if we don't do this, i18next will default to the first namespace we provide and that can cause some confusion
// by adding an empty translation namespace, users will get a lint error if they try to access a key without a namespace
const usResources = {
  translation: {},
  'alarm-moments': enUSAlarmMoments,
  'fpp-indoor-camera': enUSFppIndoorCamera,
  'fpp-outdoor-camera': enUSFppOutdoorCamera,
  contact: enUSContact,
  common: enUSCommon,
  'shop.smb': enUSShopSMB,
  shop: enUSShop,
  header: enUSHeader,
  seo: enUSSEO,
  legal: enUSLegal,
  maps: enUSMaps,
  'misc.business': enUSMiscBusiness,
  'system-advisor': enUSSystemAdvisor,
  'crime-in-the-uk': crimeInTheUk,
  test: enUSTest,
  'email-subscriptions': enUSEmailSubscriptions,
  'professional-monitoring': enUSProfessionalMonitoring,
  faqs: enUSFAQs,
  'business-expert': enUSBusinessExpert,
  'business-monitoring': enUSBusinessMonitoring
}

const ukResources = {
  translation: {},
  'alarm-moments': enGBAlarmMoments,
  'fpp-indoor-camera': enUKFppIndoorCamera,
  'fpp-outdoor-camera': enUKFppOutdoorCamera,
  contact: enGBContact,
  common: enGBCommon,
  'shop.smb': enGBShopSMB,
  shop: enGBShop,
  header: enGBHeader,
  seo: enGBSEO,
  maps: enGBMaps,
  'misc.business': enGBMiscBusiness,
  'system-advisor': enGBSystemAdvisor,
  'crime-in-the-uk': crimeInTheUk,
  test: enGBTest,
  faqs: enGBFAQs,
  'business-expert': enGBBusinessExpert
}

const mergedUS = deepmerge(ukResources, usResources)
const mergedUK = deepmerge(usResources, ukResources)

export const resources = {
  'en-US': mergedUS,
  'en-GB': mergedUK
}
